import React, { useEffect, useRef, useState } from 'react';
import { Group, Layer, Stage } from 'react-konva';
import Slide from './Slide';
import { KonvaEventObject } from 'konva/lib/Node';
import Konva from 'konva';
import './index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useSlideEditorContext } from 'providers/SlideEditorProvider';
import {
  SET_ACTIVE_SLIDE,
  SET_UPDATE_BACKGROUND
} from '../../../../reducers/SlideEditorReducer';
import NPSpinner from '../../../../components/base/NPSpinner';
import { ImageData } from '../index';
interface IProps {
  imagesRef: React.MutableRefObject<ImageData[]>;
  textsRef: React.MutableRefObject<Konva.Text[]>;
  transformerListRef: React.MutableRefObject<Konva.Transformer[]>;
}
const SlideView = ({ imagesRef, textsRef, transformerListRef }: IProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [dragStartPos, setDragStartPos] = useState(0);
  const groupRef = useRef(null);
  const { slideEditorDispatch, activeSlideIndex, slides } =
    useSlideEditorContext();

  useEffect(() => {
    setCurrentIndex(activeSlideIndex);
    animateSlide(activeSlideIndex);
  }, [activeSlideIndex]);

  const goToNextSlide = () => {
    if (animating) return;
    setAnimating(true);
    const newIndex = (currentIndex + 1) % slides.length;
    slideEditorDispatch({ type: SET_ACTIVE_SLIDE, payload: newIndex });
    animateSlide(newIndex);
    setCurrentIndex(newIndex);
  };
  const goToPreviousSlide = () => {
    if (animating) return;
    setAnimating(true);
    const newIndex = (currentIndex - 1 + slides.length) % slides.length;
    slideEditorDispatch({ type: SET_ACTIVE_SLIDE, payload: newIndex });
    animateSlide(newIndex);
    setCurrentIndex(newIndex);
  };
  const animateSlide = (newIndex: number) => {
    const newX = -newIndex * 600;
    const tween = new Konva.Tween({
      node: groupRef.current!,
      duration: 0.5,
      x: newX,
      onFinish: () => setAnimating(false)
    });
    tween.play();
  };
  const handleDragStart = (e: KonvaEventObject<DragEvent>) => {
    setDragStartPos(e.target.x());
  };
  const handleDragEnd = (e: KonvaEventObject<DragEvent>) => {
    const endPos = e.target.x();
    const distance = endPos - dragStartPos;
    if (distance < -50) {
      goToNextSlide();
    } else if (distance > 50) {
      goToPreviousSlide();
    } else {
      animateSlide(currentIndex);
    }
  };

  useEffect(() => {
    return () => {
      slideEditorDispatch({ type: SET_UPDATE_BACKGROUND, payload: false });
      transformerListRef.current = [];
      imagesRef.current = [];
      textsRef.current = [];
    };
  }, [activeSlideIndex]);

  if (slides.length === 0) {
    return <NPSpinner />;
  }

  return (
    <div
      ref={containerRef}
      style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
    >
      <Stage
        width={window.innerWidth > 600 ? 600 : window.innerWidth}
        height={window.innerHeight}
      >
        <Layer>
          <Group
            ref={groupRef}
            draggable
            dragBoundFunc={pos => ({
              x: Math.max(Math.min(pos.x, 0), -(slides.length - 1) * 600),
              y: 0
            })}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
          >
            {slides.map((slide, index) => (
              <Slide key={index} slide={slide} x={index * 600} />
            ))}
          </Group>
        </Layer>
      </Stage>
      {activeSlideIndex !== 0 && (
        <button className="btn p-0 prev-button" onClick={goToPreviousSlide}>
          <FontAwesomeIcon icon={faAngleLeft} size="4x" />
        </button>
      )}
      {slides.length - 1 !== activeSlideIndex && (
        <button className="btn p-0 next-button" onClick={goToNextSlide}>
          <FontAwesomeIcon icon={faAngleRight} size="4x" />
        </button>
      )}
    </div>
  );
};
export default SlideView;
